import { SxProps, Theme } from "@mui/material/styles";

export const HoursQuotedColumnStyle = {
  variant: "body2",
  lineHeight: "9px",
  fontSize: "12px",
  borderRadius: "5px",
  fontWeight: "450",
  padding: "7px",
  marginRight: "5px",
};

export const woCardAction = {
  display: "flex",
  flexDirection: "row",
  p: 0,
  mr: "8px",
  gap: "4px",
  mt: 1,
  alignItems: "center",
  justifyContent: "center",
};

export const statusColorCircle = {
  minWidth: "91px",
  marginRight: "10px",
  borderRadius: "5px",
  fontWeight: "600",
  fontSize: "12px",
  fontStyle: "normal",
};

export const dateRowWrapperBox = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  p: "0px",
  gap: "5px",
};

export const searchCustomerListStyle =  (theme: Theme)=> ({
  position: "absolute",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,

  top: "54px",
  listStyle: "none",
  fontSize: "14px",
  paddingRight: 0,
  zIndex: 1000,
  maxHeight: "200px",
  overflowY: "auto",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0px 4px 12px rgba(0,0,0,0.7)"
      : "0px 4px 6px rgba(0,0,0,0.1)",
});

export const searchCustomerListStyleTechnicianCalendar =  (theme: Theme) => ({
  position: "absolute",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,

  top: "40px",
  listStyle: "none",
  fontSize: "14px",
  paddingRight: 0,
  zIndex: 1000,
  maxHeight: "200px",
  overflowY: "auto",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0px 4px 12px rgba(0,0,0,0.7)"
      : "0px 4px 6px rgba(0,0,0,0.1)",
});

export const searchUnitListStyle =  (theme: Theme) => ({
  position: "absolute",
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  marginTop: "5px",
  listStyle: "none",
  fontSize: "14px",
  paddingRight: 0,
  zIndex: 1000,
  maxHeight: "120px",
  overflowY: "auto",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0px 4px 12px rgba(0,0,0,0.7)"
      : "0px 4px 6px rgba(0,0,0,0.1)",
});

export const standardJobSearchResultStyle =  (theme: Theme) => ({
  position: "absolute",
  top: "33px",
  width: "268px",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.divider}`,
  marginTop: "5px",
  listStyle: "none",
  fontSize: "14px",
  paddingRight: 0,
  zIndex: 1000,
  maxHeight: "120px",
  overflowY: "auto",
  boxShadow:
    theme.palette.mode === "dark"
      ? "0px 4px 12px rgba(0,0,0,0.7)"
      : "0px 4px 6px rgba(0,0,0,0.1)",
});

export const searchListItem = (theme: Theme) => ({
  padding: "8px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  cursor: "pointer",
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

export const searchWoItem = {
  padding: "8px",
  borderBottom: "1px solid #ccc",
  cursor: "pointer",
  "&:hover": {
    bgcolor: "rgba(0, 0, 0, 0.04)",
  },
};

export const unitDetailsCaptionStyle = {
  //color: "#6C7889",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "12px",
};
export const unitDetailsValueStyle = {
  fontWeight: "400",
  //color: "#282C33",
  fontSize: "12px",
  fontStyle: "normal",
};

export const woIconWidthHeight = {
  width: "20px",
  height: "18px",
};

export const woActionIconFontSize = "20px";

export const woActionIconButtonSx = {
  p: 0.5,
};

export const woActionIconSx = {
  fontSize: woActionIconFontSize,
};

/** Calendar glyph has extra viewBox padding; bump slightly so it matches other action icons. */
export const woCalendarIconSx = {
  fontSize: "22px",
  color: "#2196f3",
};

export const woIconWidthHeightEvent = {
  width: "20px",
  height: "18px",
  color: "#2371E7",
  cursor: "pointer",
  "&:hover": {
    color: "#2371E7",
  },
};
export const customerName = {
  fontWeight: 700,
  fontStyle: "normal",
  fontSize: "16px",
  lineHeight: "22px",
  letterSpacing: "0.01em",
};

export const timeOnChip = {
  height: "10px",
  width: "10px",
  bgcolor: "#3DA554",
  color: "white",
  marginRight: "18px",
};

export const userAvatar = {
  height: "10px",
  width: "10px",

  color: "white",
  marginRight: "2px",
};

export const extraLengthy = {
  width: "250px",
  mt: "5px",
  ml: "15px",
  p: "5px",
  height: "24px",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "12px",
  color: "#6C7889",
};

export const longTextDisplayStyle1: SxProps<Theme> = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
};

/** Shared typography for work order dashboard card detail labels and values */
export const woCardDetailLabelSx = {
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: "18px",
};

export const woCardDetailValueSx = {
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "18px",
};

export const woCardDetailBoldValueSx = {
  ...woCardDetailValueSx,
  fontWeight: 600,
};

/** Uniform row spacing for work order dashboard card detail fields */
export const woCardDetailFieldRowSx: SxProps<Theme> = {
  ...longTextDisplayStyle1,
  ml: "0px",
  py: "1px",
  px: "4px",
  minHeight: "18px",
  lineHeight: "18px",
  "& .MuiTypography-root": {
    lineHeight: "18px",
  },
};
export const longTextDisplayStyle = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  wordBreak: "break-word",
};

export const GetActiveInactiveTabColorStyle = (
  activeTabIndex: number,
  tabIndex: number,
  theme?: any,
) => {
  return {
    width: "50%",
    color: theme?.palette?.text?.secondary || "gray", // default for inactive
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "400",
    textTransform: "none",
    "&.Mui-selected": {
      color: theme?.palette?.text?.primary || "black", // active tab
      backgroundColor:
        theme?.palette?.mode === "dark"
          ? "rgba(25, 118, 210, 0.08)"
          : "#F1F6FD",
    },
    "&:hover": {
      backgroundColor:
        theme?.palette?.mode === "dark"
          ? "rgba(255, 255, 255, 0.04)"
          : "rgba(0, 0, 0, 0.04)",
    },
  };
};

export const GetActiveInactiveTabColorStyleForCalendar = (theme?: any) => {
  return {
    width: "5%",
    color: theme?.palette?.text?.secondary || "gray", // default for inactive
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "400",
    textTransform: "none",
    "&.Mui-selected": {
      color: theme?.palette?.text?.primary || "black", // active tab
      backgroundColor:
        theme?.palette?.mode === "dark"
          ? "rgba(25, 118, 210, 0.08)"
          : "#F1F6FD",
    },
    "&:hover": {
      backgroundColor:
        theme?.palette?.mode === "dark"
          ? "rgba(255, 255, 255, 0.04)"
          : "rgba(0, 0, 0, 0.04)",
    },
  };
};
export const SearchListStyle = {
  position: "absolute",
  width: "94.2%",
  backgroundColor: "#fff",
  border: "1px solid #ccc",
  marginTop: "40px",
  fontSize: "14px",
  listStyle: "none",
  paddingRight: 0,
  zIndex: 1000,
  maxHeight: "200px",
  overflowY: "auto",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
};

export const CompanySearchListStyle = {
  backgroundColor: "#fff",
};

export const ButtonStyle = {
  textTransform: "capitalize",
  fontWeight: 500,
  fontSize: "16px",
  fontStyle: "normal",
};

export const ButtonStyleOutlined = {
  fontWeight: 500,
  fontSize: "16px",
  textTransform: "capitalize",
};
